import { Link } from "react-router-dom";
import { PageHeader, Empty } from "../../components/common";
import { LandingStar } from "../../components/WeeklyStar";
import { Pill, TONE, fmtD, useLoad, useOpsMeta } from "../../lib/ops";
import { TaskActions } from "../../components/ops/TaskActions";
import { UidUpdates } from "../../components/HomeUpdates";

const TaskCard = ({ t, meta, onChanged }) => (
  <div className="ax-panel p-4" data-testid={`my-task-${t.process_id}`}>
    <div className="flex justify-between gap-2">
      <div className="min-w-0">
        <div className="font-semibold text-base">{t.name}</div>
        <div className="text-xs text-muted-foreground truncate"><span className="font-mono">{t.uid}</span> · {t.client_name}</div>
        {t.job && <div className="text-xs text-muted-foreground">{t.job}</div>}
        {!t.owner_id && t.owner_name && <div className="text-xs text-muted-foreground" data-testid={`my-task-person-${t.process_id}`}>For {t.owner_name}</div>}
      </div>
      <Pill tone={TONE[t.status]} tid={`my-task-status-${t.process_id}`}>{meta.statuses[t.status]}{t.status === "wip" ? ` ${t.progress}%` : ""}</Pill>
    </div>
    <div className="text-xs mt-2 flex flex-wrap gap-x-3 gap-y-1">
      <span>Due {fmtD(t.baseline_end || t.planned_end)}</span>
      {t.late && <span className="text-rose-600 font-medium" data-testid={`my-task-late-${t.process_id}`}>Late</span>}
      {t.update_missing && <span className="text-amber-700 font-medium">Update needed</span>}
      {t.waiting_for.length > 0 && <span className="text-muted-foreground">Waiting for {t.waiting_for.join(", ")}</span>}
      {t.block_reason && <span className="text-amber-800">Blocked: {meta.block_reasons[t.block_reason]}</span>}
      {t.rework_count > 0 && <span className="text-orange-700">Rework ×{t.rework_count}</span>}
    </div>
    <div className="mt-3"><TaskActions p={t} meta={meta} onChanged={onChanged} big /></div>
    <Link to={`/ops/uid/${t.uid}`} data-testid={`my-task-open-${t.process_id}`} className="text-xs text-primary mt-3 inline-block">Open the UID plan</Link>
  </div>
);

export default function MyOpsTasks() {
  const meta = useOpsMeta();
  const [d, load] = useLoad("/ops/my-tasks");
  if (!d || !meta) return <div className="text-sm text-muted-foreground">Loading…</div>;
  return (
    <div className="max-w-3xl">
      <PageHeader eyebrow="Operations" title="My tasks" desc={<span data-testid="my-tasks-summary">{d.items.length} open · {d.done_today} done today</span>} />
      <LandingStar />
      <UidUpdates />
      {!d.items.length ? <Empty text="No open tasks assigned to you." /> : <div className="grid gap-3" data-testid="my-tasks-list">{d.items.map((t) => <TaskCard key={t.process_id} t={t} meta={meta} onChanged={load} />)}</div>}
      {d.qc_queue.length > 0 && (
        <div className="mt-8" data-testid="qc-queue">
          <div className="ax-label mb-2">Waiting for QC ({d.qc_queue.length})</div>
          <div className="grid gap-3">{d.qc_queue.map((t) => <TaskCard key={t.process_id} t={t} meta={meta} onChanged={load} />)}</div>
        </div>)}
      {d.team_queue?.length > 0 && (
        <div className="mt-8" data-testid="team-queue">
          <div className="ax-label">Steps without a login ({d.team_queue.length})</div>
          <div className="text-xs text-muted-foreground mb-2">These people don't have a login yet, so you update their steps.</div>
          <div className="grid gap-3">{d.team_queue.map((t) => <TaskCard key={t.process_id} t={t} meta={meta} onChanged={load} />)}</div>
        </div>)}
    </div>
  );
}
